module.exports = __webpack_public_path__ + "images/bookmark-black-outline-03846234.svg";